import { useEffect, useState } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

export const YOUVE_PURCHASED_CALLOUT = 'PDP_YouvePurchasedCallout_Jun25';

export const useYouvePurchasedCalloutVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        const isYouvePurchasedCalloutVariant =
            getAbTestV2(YOUVE_PURCHASED_CALLOUT)?.variant === 'variant';

        setIsVariant(isYouvePurchasedCalloutVariant);
    }, []);

    return isVariant;
};

export const trackYouvePurchasedCallout = (): void => {
    trackAbTestV2Variant(YOUVE_PURCHASED_CALLOUT);
};
